module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "link modal__close",
    on: {
      "click": _vm.closeModal
    }
  }, [_c('span', {
    staticClass: "visuallyhidden"
  }, [_vm._v("Close modal")]), _vm._v(" "), _c('module-icon', {
    attrs: {
      "icon": "close"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d6bbbe2c"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/components/modules/modal/Close.vue
// module id = 64
// module chunks = 3